export default __webpack_public_path__ + "static/media/VerificationAccess.4bb80dcc.svg";